import { createEntityAdapter, createSlice, PayloadAction } from '@reduxjs/toolkit'
import establishmentModel, { Establishment } from '@/core/models/establishment.model'
import { RootState } from '@/redux/rootReducer'

export const establishmentAdapter = createEntityAdapter({ selectId: (establishment: Establishment) => establishment._id })
const establishmentSelector = establishmentAdapter.getSelectors((state: RootState) => state.establishment.establishments)

export const selectEstablishments = establishmentSelector.selectAll
export const selectEstablishmentById = establishmentSelector.selectById

const initialState = establishmentModel.getInitialState()

const establishmentSlice = createSlice({
  name: establishmentModel.reducerName,
  initialState,
  reducers: {
    getEstablishment(state, action: PayloadAction<string>) {
      state.requestTracker.get.loading = true
    },
    getEstablishmentSuccess(state, action: PayloadAction<Establishment>) {
      establishmentAdapter.setOne(state.establishments, action.payload)
      state.requestTracker.get.error = null
      state.requestTracker.get.loading = false
    },
    getEstablishmentFailure(state, action) {
      state.requestTracker.get.error = action.payload
      state.requestTracker.get.loading = false
    },
  },
})

export const {
  getEstablishment,
  getEstablishmentSuccess,
  getEstablishmentFailure,
} = establishmentSlice.actions

export default establishmentSlice.reducer
